// removed by extract-text-webpack-plugin
module.exports = {"container":"GalleryPhotoContainer-style__container__1iihr"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoContainer-style.scss
// module id = 1040
// module chunks = 4 22 26 29